import * as React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// import { ReceiptLongOutlined } from "@mui/icons-material";
import { getDatabase, ref, child, get } from "firebase/database";
import { useFirebase } from "../FirebaseProvider";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import { Grid, Icon } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import { Edit } from "@mui/icons-material";
import { getAuth } from "firebase/auth";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

function RecipeReviewCard({ recipe }) {
  const [expanded, setExpanded] = React.useState(false);

  const history = useHistory();

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleRecipeClick = () => {
    history.push(`recipe/${recipe.RecipedId}`);
  };
  const handleRecipeEditor = () => {
    history.push(`recipeEditor/${recipe.RecipedId}`);
  };

  return (
    <Grid container spacing={0}>
      <Card
        sx={{
          width: "100%",
          background: "linear-gradient(135deg, rgba(97, 218, 251, 0.1) 0%, rgba(153, 251, 97, 0.05) 100%)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          borderRadius: "12px",
          overflow: "hidden",
          transition: "all 0.3s ease",
          cursor: "pointer",
          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: "0 12px 24px rgba(97, 218, 251, 0.2)",
            border: "1px solid rgba(97, 218, 251, 0.3)",
          },
        }}
      >
        <CardHeader
          action={
            <IconButton
              aria-label="settings"
              sx={{
                color: "#61dafb",
                "&:hover": {
                  color: "#99fb61",
                },
              }}
              onClick={handleRecipeEditor}
            >
              <EditIcon />
            </IconButton>
          }
          title={
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "1.2rem",
                color: "#61dafb",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {recipe.RecipeName}
            </Typography>
          }
          sx={{ paddingBottom: "12px" }}
        />
        <CardMedia
          item
          component="img"
          sx={{
            height: "300px",
            objectFit: "cover",
            transition: "transform 0.3s ease",
            "&:hover": {
              transform: "scale(1.05)",
            },
            cursor: "pointer",
          }}
          image={
            recipe.PhotoUrl ||
            "https://firebasestorage.googleapis.com/v0/b/bakin-with-the-bros.appspot.com/o/images%2FBWTB%20PanCham-01.png?alt=media&token=935d360e-9c5d-4f2e-92a6-49be1f0101fd"
          }
          alt="Recipe Photos"
          onClick={handleRecipeClick}
        />

        <CardContent sx={{ paddingTop: "16px" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Avatar
              alt={recipe.userDisplayName}
              src={recipe.userPhoto}
              sx={{ width: 40, height: 40 }}
            />

            <Typography
              sx={{
                fontSize: "0.9rem",
                color: "rgba(255, 255, 255, 0.8)",
                flex: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              variant="body2"
            >
              {`Posted by: ${recipe.userDisplayName}`}
            </Typography>
          </Box>
        </CardContent>
        <CardActions disableSpacing sx={{ paddingTop: 0 }}>
          <Typography
            variant="body2"
            sx={{
              color: "#99fb61",
              fontSize: "0.85rem",
              fontWeight: "600",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Ingredients
          </Typography>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
            sx={{
              color: "#61dafb",
              "&:hover": {
                color: "#99fb61",
              },
            }}
          >
            <ExpandMoreIcon />
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <Typography
              paragraph
              sx={{
                color: "#99fb61",
                fontWeight: "600",
                marginBottom: "12px",
              }}
            >
              <h3 style={{ margin: 0, fontSize: "1.1rem" }}>Ingredients</h3>
            </Typography>
            <Typography paragraph sx={{ color: "rgba(255, 255, 255, 0.9)" }}>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    recipe && recipe.IngredientList
                      ? recipe.IngredientList
                      : "",
                }}
              />
            </Typography>
          </CardContent>
        </Collapse>
      </Card>
    </Grid>
  );
}

export default function MyRecipes() {
  const firebase = useFirebase();
  const [recipes, setRecipes] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  // const starCountRef = ref(database, 'recipes/');
  // onValue(starCountRef, (snapshot) => {
  //   const data = snapshot.val();
  //   updateStarCount(postElement, data);
  // });

  React.useEffect(() => {
    if (firebase) {
      const auth = getAuth();
      const user = auth.currentUser;
      const database = getDatabase(firebase.app);
      const dbRef = ref(database);
      get(child(dbRef, `recipes/`)).then(async (snapshot) => {
        console.log(snapshot);
        if (snapshot.exists()) {
          const recipeList = Object.entries(snapshot.val()).map(([k, v]) => ({
            RecipedId: k,
            ...v,
          }));
          const recipeListSorted = recipeList.sort((a, b) =>
            new Date(a.TimeStamp) < new Date(b.TimeStamp) ? 1 : -1
          );
          const userRecipes = recipeListSorted.filter(
            (x) => x.userId === user.uid
          );
          const recipeListWithUsers = await Promise.all(
            userRecipes.map(async (recipe) => {
              const snapshot = await get(
                child(dbRef, `user_meta/${recipe.userId}`)
              );
              console.log(snapshot);
              if (snapshot.exists()) {
                console.log(snapshot.val());
                return {
                  ...recipe,
                  userPhoto: snapshot.val().photoURL,
                  userDisplayName: snapshot.val().displayName,
                };
              }
              return recipe;
            })
          );

          setRecipes(recipeListWithUsers);
          console.log(recipeListWithUsers);
        } else {
          console.log("No data available");
        }
      });
    }
  }, [firebase]);

  return recipes.length ? (
    <Grid
      container
      spacing={3}
      sx={{
        margin: "0",
        padding: "40px 20px",
        maxWidth: "1400px",
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
        bgcolor: "#282c34",
        minHeight: "100vh",
      }}
      columns={{ xs: 4, sm: 8, md: 12, lg: 16 }}
    >
      {recipes.map((recipe) => {
        return (
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            lg={4}
            key={recipe.RecipedId}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <RecipeReviewCard recipe={recipe} />
          </Grid>
        );
      })}
    </Grid>
  ) : (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
        color: "white",
        fontSize: "1.2rem",
        bgcolor: "#282c34",
      }}
    >
      Loading your recipes...
    </Box>
  );
}
